import NationalID from "../pages/nationalId/NationalID";
import localStorageString from "./localStorageString";

const strings = {
  navigation: {
    welcome: "/",
    patientProfiles: "/patient-profiles",
    patientProfileDetails: "/patient-profile-details",
    department: "/department",
    departmentPrice: "/department-price",
    patientDetail: "/patientDetail",
    additionalConsumables: "/additional-consumables",
    hn_verify: "/hn-verify",
    manage_nurse: "/manage_nurse",
    manageService: "/manage-service",
    additionalConsumableList: "/manage-resource/additonal-consumable-list",
    addConsumable: "/manage-resource/add-consumable",
    editConsumable: "/manage-resource/edit-consumable",
    nurseList: "/manage-resource/nurse-list",
    createNurse: "/manage-resource/add-nurse",
    editNurse: "/manage-resource/get-nurse/:nurseId",
    patientProfile: "/patient-profile",
    manageAmbulance: "/manage-vehicles",
    manageDriver: "/manage-driver",
    manageNurseReq: "/nurse-requests",
    viewNurseReqDetails: "/nurse-requests/details",
    healthArticle: "/health-articles",
    nationalID: "/national-id",
    termsCondition: "/t&c_pp",
    viewTermsCondition: "/t&c_pp/view",
    updateTermsCondition: "/t&c_pp/update",
    nursingCareManageService: "/nursing-care/manage-service",
    createService: "/nursing-care/manage-service/create-service",
    serviceDetail: "/nursing-care/manage-service/service-detail",
  },
  departments: ["Cardiology", "Nephrology", "Neurology", "Orthopedics", "Pediatrics", "Oncology", "Gastroenterology", "Dermatology", "Endocrinology"],
  ...localStorageString,
};

export default strings;
